<app-base-modal
  [title]="'Добавить предложение о сотрудничестве'"
>
  <mat-stepper
    #stepper
    [linear]="false"
    [orientation]="isMobile ? 'vertical' : 'horizontal'"
  >
    <mat-step
      label="Добавление"
      [stepControl]="formGroup"
    >
      <app-form-cooperation-offer
        [formGroup]="formGroup"
        [currentStep]="stepper.selectedIndex"
        (nextStep)="nextStep()"
      />
    </mat-step>
    <mat-step label="Проверка повторов">
      <div class="repeats">
        Повторы:
        @if (repeatsData().length) {
          <ul class="cooperation-list">
            @for (repeat of repeatsData(); track $index) {
              <li class="cooperation-list-item">
                <div class="bold">{{ repeat['plannedDate'] }}</div>
                <div
                  class="manager-name"
                  [class]="getManagerNameColorClass(repeat['own'])"
                >
                  {{ repeat['managerName'] }}
                </div>
                <div>{{ repeat['productName'] }}</div>
                <div>{{ repeat['channelName'] }}</div>
                <div class="full-width-line">
                  <div>cpa: {{ Number(repeat['cpa']) | formatNumber }}</div>
                  <div>cpv: {{ Number(repeat['cpv']) | formatNumber }}</div>
                </div>
                <a
                  class="link full-width-line"
                  [href]="repeat['channelUrl']"
                  target="_blank"
                >
                  {{ repeat['channelUrl'] }}
                </a>
                <div class="separator"></div>
              </li>
            }
          </ul>
        } @else {
          <p class="cooperation-no-repeat">Повторы не найдены</p>
        }
      </div>
      <div class="cooperation-buttons">
        <button
          mat-button
          color="warn"
          type="button"
          (click)="closeDialog('cancel')"
        >
          Отмена
        </button>
        <button
          mat-button
          matStepperNext
          color="primary"
          type="button"
          (click)="createRepeat()"
        >
          Добавить
        </button>
      </div>
    </mat-step>
    <mat-step label="Готово">
      <app-form-cooperation-offer
        [formGroup]="formGroup"
        [currentStep]="stepper.selectedIndex"
        (handleClose)="closeDialog($event)"
      />
    </mat-step>
  </mat-stepper>
</app-base-modal>
